'use client'

import React from 'react'

import { CMSLink } from '@/components/Link'
import type { Header as HeaderType } from '@/payload-types'

export const HeaderNav: React.FC<{ data: HeaderType }> = ({ data }) => {
  const navItems = data?.navItems || []

  return (
    <nav className="flex gap-3 items-center" aria-label="Desktop navigation">
      {navItems.map(({ link }, i) => {
        return <CMSLink key={i} {...link} appearance="link" trackAs="nav_item" />
      })}
    </nav>
  )
}
